module.exports = __webpack_public_path__ + "static/mobilitat2-46867d4b9aff7446ff8a29b9cecfae11.png";